import { Outlet } from 'react-router-dom'
import { BrandModeProvider, type BrandMode } from '../contexts/BrandModeContext'
import { GrainOverlay } from '@/components/ui'
import SiteHeader from '../components/header/SiteHeader'
import IdFooter from '../components/IdFooter'
import ScrollToTop from '../components/ScrollToTop'

interface IdLayoutProps {
  brandMode?: BrandMode
}

export default function IdLayout({ brandMode = 'A' }: IdLayoutProps) {
  return (
    <BrandModeProvider mode={brandMode}>
      {brandMode === 'A' && <GrainOverlay opacity={0.015} />}
      <ScrollToTop />
      <SiteHeader />
      <main
        id="main-content"
        className="min-h-screen"
        style={{ paddingTop: 'var(--header-top-height)' }}
      >
        <Outlet />
      </main>
      <IdFooter />
      {/* Bottom bar spacer on mobile */}
      <div className="h-14 md:hidden" aria-hidden="true" />
    </BrandModeProvider>
  )
}
